<template>
  <div>
    <li class="soha-list-item">
      <div
        v-if="loading"
        class="w-100 text-center"
      >
        <loading        
          size="8"
        />
      </div>
      <div v-else>
        <span
          v-if="icon"
          :class="['svg-icon', `svg-icon-${iconColor}`]"
        >
          <inline-svg :src="`/media/svg/soha/icons/${icon}.svg`" />
        </span>
        <div
          v-else
          class="soha-empty-panel"
        />
        <span class="ml-2">{{ text }}</span>
      </div>
    </li>
  </div>
</template>

<script>
import "@/assets/css/components/base/list-item.css";
import Loading from "@/view/components/base/Loading";

export default {
  name: "ListItem",

  props: {
    text: {
      type: String,
      require: true,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: "primary",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Loading,
  },
};
</script>
